/** Client-safe purchase handoff path check (no server deps). */
export function isPurchaseHandoffPath(pathOrUrl: string | null | undefined): boolean {
  if (!pathOrUrl) return false;
  try {
    const pathname = pathOrUrl.startsWith('http')
      ? new URL(pathOrUrl).pathname
      : pathOrUrl.split('?')[0];
    return pathname === '/purchase' || pathname.startsWith('/purchase/');
  } catch {
    return pathOrUrl.includes('/purchase');
  }
}

/** Pull `priceId` out of a `/purchase?priceId=…` path+query string (no server deps, no trust). */
export function extractPurchasePriceId(pathOrUrl: string | null | undefined): string | undefined {
  if (!pathOrUrl) return undefined;
  try {
    const query = pathOrUrl.startsWith('http')
      ? new URL(pathOrUrl).search
      : `?${pathOrUrl.split('?')[1] ?? ''}`;
    const priceId = new URLSearchParams(query).get('priceId')?.trim();
    return priceId || undefined;
  } catch {
    return undefined;
  }
}
